module.exports = __webpack_public_path__ + "static/img/far1_active.04717654.png";